const state = {
  data: null,
  pending: false,
  maintenanceIsOn: false,
  error: null,
  updatePending: false,
  updateError: null,
};

const getters = {
};

const mutations = {
  clearErrors() {
    //
  },
};
const actions = {
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
